import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import { formatCurrency } from '../../utils/formatters';
import api from '../../utils/api';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const ProductMovementsDialog = ({ open, onClose, productId }) => {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open && productId) {
      fetchMovements();
    }
  }, [open, productId]);

  const fetchMovements = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('Fetching movements for product:', productId);
      const response = await api.get(`/warehouse-movements/product/${productId}`);
      console.log('Movements response:', response.data);
      setMovements(response.data);
    } catch (err) {
      console.error('Errore nel caricamento movimenti:', err);
      setError('Errore nel caricamento dei movimenti di magazzino');
    } finally {
      setLoading(false);
    }
  };

  const formatMovementType = (type) => {
    switch (type) {
      case 'IN':
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <AddCircleOutlineIcon color="success" />
            <Typography>Entrata</Typography>
          </Box>
        );
      case 'OUT':
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <RemoveCircleOutlineIcon color="error" />
            <Typography>Uscita</Typography>
          </Box>
        );
      default:
        return type;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Movimenti di Magazzino</Typography>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" p={2}>
            {error}
          </Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width="180px">Data</TableCell>
                  <TableCell width="120px">Tipo</TableCell>
                  <TableCell width="100px" align="right">Quantità</TableCell>
                  <TableCell width="120px" align="right">Prezzo</TableCell>
                  <TableCell width="150px">Motivo</TableCell>
                  <TableCell>Note</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {movements.map((movement) => (
                  <TableRow key={movement.id}>
                    <TableCell>
                      {new Date(movement.movementDate || movement.createdAt).toLocaleString('it-IT', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </TableCell>
                    <TableCell>{formatMovementType(movement.type)}</TableCell>
                    <TableCell align="right">{movement.quantity}</TableCell>
                    <TableCell align="right">
                      {movement.price ? formatCurrency(movement.price) : '-'}
                    </TableCell>
                    <TableCell>{movement.reason || '-'}</TableCell>
                    <TableCell>{movement.notes || '-'}</TableCell>
                  </TableRow>
                ))}
                {movements.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      Nessun movimento trovato
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductMovementsDialog; 